import styled from 'styled-components';
import { FlexColumn, FlexRow, Text } from '@make-software/tg-mini-app-ui';

export const InfoContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    padding: '20px',
    background: '#3A3B46',
    marginBottom: '10px',
    borderRadius: '8px'
  })
);

export const TokenSymbol = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontSize: '28px',
    color: theme.colors.lightGray,
    fontFamily: theme.typography.fontFamily.display,
    fontWeight: 700,
    lineHeight: '140%'
  })
);

export const AwardText = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: theme.colors.mainWhite,
    fontFamily: theme.typography.fontFamily.display,
    fontWeight: 700,
    lineHeight: '140%',
    fontSize: '28px'
  })
);

export const StyledAwarded = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    fontSize: '14px',
    color: theme.colors.mainGray,
    fontFamily: theme.typography.fontFamily.sans,
    fontWeight: 400,
    lineHeight: '140%'
  })
);

export const StyledDateText = styled.span(({ theme }) =>
  theme.withMedia({
      fontSize: '14px',
      color: theme.colors.mainWhite,
      fontFamily: theme.typography.fontFamily.sans,
      fontWeight: 400,
      lineHeight: '140%'
  })
);

export const LeaderBoardRow = styled(Text)(({ theme }) =>
  theme.withMedia({
    display: 'block',
    margin: '24px 0 8px 0',
    color: 'white',
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily.sans,
    fontSize: '19px'
  })
);

export const EligibleUsersRow = styled(Text)(({ theme }) =>
  theme.withMedia({
    display: 'block',
    margin: '24px 0 8px 0'
  })
);

export const ButtonWrapper = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    margin: '0'
  })
);
